const isIdApp = () => {
	const id_app = localStorage.getItem("id_app");
	return id_app ? true : false;
};

export default isIdApp;
